import 'isomorphic-fetch';

interface FetchDocumentProps {
  readonly documentId: string;
  readonly faServicesUrl: string;
  readonly apiKey: string;
}

export const fetchDocument = async ({ documentId, faServicesUrl, apiKey }: FetchDocumentProps): Promise<Blob> => {
  const url: string = `${faServicesUrl}/maintenance/document/${documentId}`;

  const response = await fetch(url, { headers: { 'x-api-key': apiKey } })

  if (response.status >= 400) {
    throw new Error(`Failed to fetch document: ${response.status} ${response.statusText}`);
  }

  const document = await response.blob();

  return document;
}